<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>Change Icon</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <div class="tw:h-full tw:w-full tw:content-center tw:items-center">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="10" offset-sm="1" size-lg="4" offset-lg="4">
          <ion-text class="tw:text-center tw:text-xl">
            <h1 class="tw:p-2">Do you want to use this as the application icon?</h1>
          </ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-sm="10" offset-sm="1" size-lg="4" offset-lg="4" class="tw:flex tw:justify-center">
          @if (alternateAppIconPreviewUrl) {
          <div class="tw:relative tw:h-64 tw:w-64 tw:p-2">
            <img alt="Alternate Icon" class="tw:object-contain" ngSrc="{{ alternateAppIconPreviewUrl }}" fill />
          </div>
          }
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-sm="10" offset-sm="1" size-lg="4" offset-lg="4" class="tw:text-center">
          <ion-text color="primary" class="tw:font-bold"> {{ applicationName }} </ion-text>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" size-sm="10" offset-sm="1" size-lg="4" offset-lg="4" class="tw:text-center">
          <ion-text class="tw:text-xs">
            You can revert back to the original application icon at any time by going to the application settings.
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</red-page-content>

<red-footer-content>
  <ion-toolbar>
    <ion-buttons class="tw:justify-between tw:px-4">
      <ion-button (click)="onSubmit(true)"><ion-icon name="close-circle-outline"></ion-icon>No</ion-button>
      <ion-button color="primary" (click)="onSubmit(false)">
        Yes<ion-icon name="checkmark-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-footer-content>
